import { render, staticRenderFns } from "./IssuerDetailsDialog.vue?vue&type=template&id=580fad80"
import script from "./IssuerDetailsDialog.vue?vue&type=script&lang=js"
export * from "./IssuerDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports